import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FileUploadModule } from 'ng2-file-upload';

import { DialogImageUploadModule } from './dialog-image-upload/dialog-image-upload.module';
import { ToastModule } from '@libs/src/toast/toast.module';

import { UploadService } from './upload.service';
import { UploadDialogService } from '@main-client/src/app/upload/upload-dialog.service';

import { UploadFileComponent } from './upload-file.component';

@NgModule({
  imports: [
    CommonModule,
    DialogImageUploadModule,
    FileUploadModule,
    MatButtonModule,
    MatDialogModule,
    ToastModule,
  ],
  declarations: [UploadFileComponent],
  providers: [UploadService, UploadDialogService],
  exports: [UploadFileComponent],
})
export class UploadModule {}
